import { Star, Quote } from 'lucide-react';

export default function Reviews() {
  const reviews = [
    {
      name: "Priya Sharma",
      role: "HR Manager",
      text: "GreenTick has completely transformed our hiring process. The AI-driven screening has saved us countless hours.",
      rating: 5
    },
    {
      name: "Rajesh Kapoor",
      role: "Talent Acquisition Lead",
      text: "The dynamic questioning feature is a game-changer. It's like having a skilled interviewer available 24/7.",
      rating: 5
    },
    {
      name: "Sunita Patel",
      role: "Senior HR Executive",
      text: "Instant feedback keeps candidates engaged and informed, which reflects positively on our employer brand.",
      rating: 5
    },
    {
      name: "Vikram Menon",
      role: "HR Director",
      text: "Detailed candidate reports provide invaluable insights. It has improved our overall hiring quality.",
      rating: 5
    },
    {
      name: "Anjali Rao",
      role: "Placement Coordinator",
      text: "GreenTick has revolutionized our campus placements. Students get the best possible opportunities.",
      rating: 5
    },
    {
      name: "Arjun Sethi",
      role: "IT Consultant",
      text: "The AI-driven resume screening is incredibly efficient. Only the most qualified candidates make it through.",
      rating: 5
    }
  ];

  const duplicatedReviews = [...reviews, ...reviews, ...reviews];

  return (
    <div className="py-32 bg-transparent relative overflow-hidden">

      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 right-20 w-96 h-96 bg-emerald-500 rounded-full filter blur-3xl opacity-20 animate-pulse"></div>
        <div className="absolute bottom-20 left-20 w-96 h-96 bg-teal-500 rounded-full filter blur-3xl opacity-20 animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 mb-6">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-6 h-6 fill-amber-400 text-amber-400" />
            ))}
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-4">
            Trusted by Industry Leaders
          </h2>
          <p className="text-xl text-slate-400">
            4.8/5 stars from over 100+ reviews
          </p>
        </div>

        <div className="relative max-w-screen-2xl mx-auto">
          <div className="relative rounded-3xl border-2 border-teal-500/30 bg-gradient-to-r from-teal-500/5 via-transparent to-emerald-500/5 p-8 backdrop-blur-sm shadow-[0_0_50px_rgba(20,184,166,0.15)]">
            <div className="overflow-hidden">
              <div className="flex gap-6 animate-testimonial-scroll hover:animation-paused">
                {duplicatedReviews.map((review, index) => (
                  <div
                    key={index}
                    className="relative group flex-shrink-0 w-[400px]"
                  >
                    <div className="absolute inset-0 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-3xl blur-xl opacity-0 group-hover:opacity-30 transition-opacity"></div>
                    <div className="relative glass-dark p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all border border-white/10 group-hover:border-emerald-500/50 h-full">
                      <Quote className="w-10 h-10 text-emerald-500 mb-4" />
                      <div className="flex gap-1 mb-4">
                        {[...Array(review.rating)].map((_, i) => (
                          <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
                        ))}
                      </div>
                      <p className="text-slate-300 mb-6 leading-relaxed">
                        {review.text}
                      </p>
                      <div className="border-t border-white/10 pt-4">
                        <p className="font-bold text-white">{review.name}</p>
                        <p className="text-sm text-slate-400">{review.role}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
